<template>
  <ElImage ref="image" v-bind="$attrs" :src="src" :preview-src-list="mobilePreview ? [] : previewSrcList" :initial-index="initialIndex" :style="mobilePreview && previewSrcList.length ? { cursor: 'pointer' } : null" @click="mobilePreview ? openPreview() : undefined">
    <template v-for="(_, name) in $slots" #[name]="scope"><slot :name="name" v-bind="scope || {}" /></template>
  </ElImage>
  <ImageViewer v-if="previewOpen" v-bind="viewerAttrs" :url-list="previewSrcList" :initial-index="initialIndex" :download="download" @close="closePreview" @switch="$emit('switch', $event)">
    <template v-if="$slots.toolbar" #toolbar="scope"><slot name="toolbar" v-bind="scope || {}" /></template>
    <template v-if="$slots.progress" #progress="scope"><slot name="progress" v-bind="scope || {}" /></template>
    <template v-if="$slots['viewer-error']" #viewer-error="scope"><slot name="viewer-error" v-bind="scope || {}" /></template>
    <template v-if="$slots.viewer" #default><slot name="viewer" /></template>
  </ImageViewer>
</template>

<script>
import { ElImage } from 'element-plus'
import ImageViewer from './ImageViewer.vue'
import { isPhoneWorkspace } from '@/views/mobile/shared/displayState'
import { useDisplayState } from '@/views/mobile/shared/useDisplayState'

export default {
  name: 'AppPreviewImage',
  inheritAttrs: false,
  components: { ElImage, ImageViewer },
  setup() { return useDisplayState() },
  props: {
    src: { type: String, default: '' },
    previewSrcList: { type: Array, default: () => [] },
    initialIndex: { type: Number, default: 0 },
    download: { type: Function, default: null }
  },
  emits: ['show', 'close', 'switch'],
  data() { return { previewOpen: false } },
  computed: {
    mobilePreview() {
      return this.displayState.layoutMode === 'mobile' || isPhoneWorkspace(this.displayState)
    },
    viewerAttrs() {
      const names = ['zIndex', 'z-index', 'infinite', 'zoomRate', 'zoom-rate', 'minScale', 'min-scale', 'maxScale', 'max-scale', 'scale', 'showProgress', 'show-progress', 'hideOnClickModal', 'hide-on-click-modal', 'closeOnPressEscape', 'close-on-press-escape', 'crossorigin']
      const attrs = Object.fromEntries(Object.entries(this.$attrs).filter(([name]) => names.includes(name)))
      attrs.teleported = this.$attrs.previewTeleported ?? this.$attrs['preview-teleported'] ?? false
      return attrs
    }
  },
  watch: {
    previewSrcList(list) { if (!list.length) this.closePreview() },
    src() { this.closePreview() }
  },
  beforeUnmount() { this.closePreview() },
  methods: {
    openPreview() {
      if (!this.mobilePreview || this.previewOpen || !this.previewSrcList.length) return
      this.previewOpen = true
      this.$emit('show')
    },
    closePreview() {
      if (!this.previewOpen) return
      this.previewOpen = false
      this.$emit('close')
    },
    showPreview() {
      if (this.mobilePreview) this.openPreview()
      else this.$refs.image?.showPreview()
    }
  }
}
</script>
